import { render, staticRenderFns } from "./ModelCallSetting.vue?vue&type=template&id=3b91462e&scoped=true&"
import script from "./ModelCallSetting.vue?vue&type=script&lang=js&"
export * from "./ModelCallSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b91462e",
  null
  
)

export default component.exports